import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index(params) {
    const url = apiRoutes.apiV1RealEstateAgentWaitlistLoanOfficersPath();

    return FetchHelpers.get(url, params);
  },

  update(id, params) {
    const url = apiRoutes.apiV1RealEstateAgentWaitlistLoanOfficerPath(id);

    return FetchHelpers.put(url, params);
  },

  batchUpdate(params) {
    const url = apiRoutes.apiV1RealEstateAgentWaitlistLoanOfficersBatchUpdatePath();

    return FetchHelpers.put(url, params);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/realEstateAgent/WaitlistLoanOfficersRepository.js